/**
 * Native view contract that PostHog recognises as an uncaptured subtree.
 * Keeping the marker here confines vendor knowledge to observability while
 * allowing credential controls to enforce their own replay floor.
 */
export const sessionReplayMaskProps = Object.freeze({
  accessibilityLabel: 'ph-no-capture',
  importantForAccessibility: 'no' as const,
  collapsable: false,
});
